import { ReactElement } from "react";
import { Navigate } from "react-router-dom-v5-compat";

import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

import { ROUTES } from "routing/routes";

import { useAssignmentJourneyFormControls } from "../../../../hooks/useAssignmentJourneyFormControls";

export function CreateAssignmentClassRoutingWrapper({
  children
}: {
  children: ReactElement;
}) {
  const state = useTypedState(ROUTES.TEACHER.ASSIGNMENTS.CREATE.CLASS);
  const { withClassSelection, classId, fromPreviousLink } = state;
  const { setValue } = useAssignmentJourneyFormControls();

  // When coming from class page, we know the classId, so we can set it in the form and move to next step
  if (!fromPreviousLink && !!classId) {
    setValue("classIds", [classId]);

    return (
      <Navigate
        to={ROUTES.TEACHER.ASSIGNMENTS.CREATE.TYPE.buildPath({})}
        state={state}
        replace
      />
    );
  }

  // If user accesses page directly, we need to set this state value
  // since it's used to identify the class selection is part of the journey
  if (!withClassSelection) {
    return (
      <Navigate
        to="."
        state={ROUTES.TEACHER.ASSIGNMENTS.CREATE.CLASS.buildState({
          ...state,
          withClassSelection: true
        })}
        replace
      />
    );
  }

  return children;
}
